import React from "react";
import { Button } from "semantic-ui-react";
import { Modal } from "../../../components";
interface Props {
  contactId: number
  companyWithWorkRelation: server.dto.CompanyWithWorkRelation
  onClose: (hasChanged: boolean) => void
}

const UnlinkModal = (props: Props) => {
  const [isChangingActiveness, setIsChangingActiveness] = React.useState(false);
  const [isDeletingLink, setIsDeletingLink] = React.useState(false);

  const isSaving = isChangingActiveness || isDeletingLink;

  const onDeactivateClicked = async (newActiveStatus: boolean) => {
    setIsChangingActiveness(true);

    const instruction: server.dto.SetCompanyToContactLinkInstruction = {
      companyId: props.companyWithWorkRelation.company.companyId,
      contactId: props.contactId,
      isActive: newActiveStatus,
      defaultSelect: props.companyWithWorkRelation.defaultSelect
    };

    await window.CoreApi.CompanyToContact.SetLink(instruction);
    props.onClose(true);
  };

  const deleteLink = async () => {
    setIsDeletingLink(true);

    const instruction: server.dto.DeleteCompanyToContactLinkInstruction = {
      companyId: props.companyWithWorkRelation.company.companyId,
      contactId: props.contactId
    };

    await window.CoreApi.CompanyToContact.DeleteLink(instruction);

    props.onClose(true);
  };

  return <Modal
    title={""}
    style={{ width: 500 }}
    displayHeader={false}
    isOpen
    gap="regular"
    handleClose={() => { props.onClose(false); }}
  >
    <Button
      primary
      type="button"
      disabled={isSaving}
      onClick={async () => onDeactivateClicked(!props.companyWithWorkRelation.isActive)}
      loading={isChangingActiveness}
    >
      {props.companyWithWorkRelation.isActive ? RESX.Company.KeepTheLink : RESX.Company.ReactivateTheLink}
    </Button>

    <Button
      type="button"
      color="blue"
      disabled={isSaving}
      onClick={deleteLink}
      loading={isDeletingLink}
    >
      {RESX.Company.RemoveLinkBetweenThisCompanyAndContact}
    </Button>
  </Modal>;
};

export default UnlinkModal;